import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60df641c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Akce klubu", -1))
const _hoisted_2 = { class: "events" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "sold-out"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Vyprodáno", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "sold-out"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Zrušeno", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 2 }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const events = [
  {
    id: "eve-1",
    title: "Oravice - Roháče",
    link: "/akce-klubu/oravice-rohace",
    description: "Lyžování na Slovensku",
  },
  {
    id: "eve-2",
    title: "Bystřička",
    zruseno: true,
    link: "/akce-klubu/bystricka",
    description: "Sjezd divoké řeky",
  },
  // {
  //   id: "eve-3",
  //   title: "Řecko - korfu",
  //   link: "/akce-klubu/recko",
  //   description: "Řecko a potápění",
  // },
  {
    id: "eve-4",
    title: "Zlatý Dunajec",
    vyprodano: false,
    link: "/akce-klubu/dunajec",
    description:
      "Plavba kaňonem zaříznutým hluboko do skal, peřejnatá řeka, stromy nádherně obarvené podzimem...",
  },
  {
    id: "eve-5",
    title: "Vodácké a turistické kurzy",
    link: "/akce-klubu/kurzy",
    description: "",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(events, (event) => {
        return _createElementVNode("li", {
          key: event.id
        }, [
          _createElementVNode("a", {
            href: event.link
          }, [
            _createElementVNode("h3", null, _toDisplayString(event.title), 1),
            (event.vyprodano)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : _createCommentVNode("", true),
            (event.zruseno)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(event.description), 1))
          ], 8, _hoisted_3)
        ])
      }), 64))
    ])
  ], 64))
}
}

})